import React, { useState } from 'react';
import { APIProvider, Map, AdvancedMarker, Pin, InfoWindow } from '@vis.gl/react-google-maps';
import styles from "../../styles/ScreeningPlantsMap.module.css";

const ProjectMap = ({ apiKey }) => {
    // Define your cities data
    const plants = [
        { name: 'Screening Plant 1', imgUrl: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTBGqCHZ3EngTD0GcZdAnspOrdiV6VXJ27D0Q&s', location: 'Kirandul, Chhattisgarh, India', lat: 18.6334, lng: 81.2559, info: 'Known as the "Steel City" of Haryana.' },
        { name: 'Screening Plant 2', imgUrl: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTBGqCHZ3EngTD0GcZdAnspOrdiV6VXJ27D0Q&s', location: 'Bacheli, Chhattisgarh, India', lat: 18.6695, lng: 81.26861, info: 'A historic city, one of the oldest in Haryana.' },
        { name: 'Screening Plant 3', imgUrl: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTBGqCHZ3EngTD0GcZdAnspOrdiV6VXJ27D0Q&s', location: 'Jagdalpur, Chhattisgarh, India', lat: 19.0861, lng: 82.0188, info: 'Often called "Mini Cuba" due to its boxing talent.' },
        { name: 'Screening Plant 4', imgUrl: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTBGqCHZ3EngTD0GcZdAnspOrdiV6VXJ27D0Q&s', location: 'Donimalai, Karnataka, India', lat: 15.0621, lng: 76.5965, info: 'Named after Fateh Khan, son of Firoz Shah Tughlaq.' }
    ];

    // State to manage which InfoWindow is currently open
    const [openInfoWindowIndex, setOpenInfoWindowIndex] = useState(null);

    // Calculate the approximate center of all plants
    const avgLat = plants.reduce((sum, plant) => sum + plant.lat, 0) / plants.length;
    const avgLng = plants.reduce((sum, plant) => sum + plant.lng, 0) / plants.length;
    const mapCenter = { lat: avgLat, lng: avgLng };

    return (
        <div className={styles.mapContainer}>

            <APIProvider apiKey={`${process.env.REACT_APP_MAP_API_KEY}`}>
                <Map
                    defaultCenter={mapCenter}
                    defaultZoom={6}
                    gestureHandling={'greedy'}
                    mapId="default"

                >
                    {plants.map((plant, index) => (
                        <AdvancedMarker
                            key={index} // Unique key for each marker in the list
                            position={{ lat: plant.lat, lng: plant.lng }}
                            title={plant.name}
                            onMouseOver={() => setOpenInfoWindowIndex(index)} // Open InfoWindow on hover
                            onMouseOut={() => setOpenInfoWindowIndex(null)} // Close InfoWindow on mouse out
                            onClick={() => { // Optional: Also open on click and center map
                                setOpenInfoWindowIndex(index);
                                // You might want to programmatically center the map here if not using defaultCenter
                                // map.setCenter({ lat: plant.lat, lng: plant.lng });
                            }}
                        >
                            {/* You can customize the marker icon here if needed, e.g., <img src={plant.iconUrl} /> */}
                            <Pin background={'#1a73e8'} borderColor={'#0f4c81'} glyphColor={'#fff'} />

                            {openInfoWindowIndex === index && (
                                <InfoWindow
                                    position={{ lat: plant.lat, lng: plant.lng }}
                                    onCloseClick={() => setOpenInfoWindowIndex(null)} // Close if user clicks 'x'
                                >
                                    <div className={styles.infoContent}>
                                        <img src={plant.imgUrl} alt={plant.name} className={styles.infoImage} />
                                        <h3 className={styles.infoTitle}>{plant.name}</h3>
                                        <h5 className={styles.infoLocation}>{plant.location}</h5>
                                        <p className={styles.infoCompletion}><b>% Completion: </b>75%</p>
                                    </div>
                                </InfoWindow>
                            )}
                        </AdvancedMarker>
                    ))}
                </Map>
            </APIProvider>
        </div>
    );
};

export default ProjectMap;